/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */

// Shop specific - Unified container for all shop pages
import ShopTabbedMain from "../components/pages/user/shop/ShopTabbedMain";


export const MarketLocalCommonRoutes = [

  // ALL shop pages use the unified ShopTabbedMain container
  // This provides consistent header, navigation, and back button behavior
  
  // Main shop pages with tabs
  { path: "/shop/:shopId", component: ShopTabbedMain, exact: true },
  { path: "/shop/:shopId/products", component: ShopTabbedMain, exact: true },
  { path: "/shop/:shopId/cart", component: ShopTabbedMain, exact: true },
  { path: "/shop/:shopId/account", component: ShopTabbedMain, exact: true },

  // Product pages
  { path: "/shop/:shopId/products/sort/:sort", component: ShopTabbedMain, exact: true },
  { path: "/shop/:shopId/products/search", component: ShopTabbedMain, exact: true },
  { path: "/shop/:shopId/products/search/:query", component: ShopTabbedMain, exact: true },
  { path: "/shop/:shopId/products/:prodId", component: ShopTabbedMain, exact: true },

  // Checkout flow
  { path: "/shop/:shopId/cart/checkout", component: ShopTabbedMain },
  { path: "/shop/:shopId/cart/payment-page", component: ShopTabbedMain },
  { path: "/shop/:shopId/cart/order-success", component: ShopTabbedMain },

  // Account and other pages
  { path: "/shop/:shopId/account/orders", component: ShopTabbedMain, exact: true },
  { path: "/shop/:shopId/account/orders/:orderId", component: ShopTabbedMain, exact: true },
  { path: "/shop/:shopId/account/wishlist", component: ShopTabbedMain, exact: true },
  { path: "/shop/:shopId/account/appointments", component: ShopTabbedMain, exact: true },
  { path: "/shop/:shopId/account/addresses", component: ShopTabbedMain, exact: true },
  { path: "/shop/:shopId/account/mytryons", component: ShopTabbedMain, exact: true },
  { path: "/shop/:shopId/account/tryonprofile", component: ShopTabbedMain, exact: true },

];
